export const listFormat = (list: Array<JSX.Element | string>) => {
	const getSeparator = (index: number, array: Array<JSX.Element | string>) => {
		switch (index) {
			case 0:
				return '';
			case array.length - 1:
				return ' and ';
			default:
				return ', ';
		}
	};

	return list.reduce<Array<JSX.Element | string>>(
		(accumulator, value, index, array) => {
			return [...accumulator, getSeparator(index, array), value];
		},
		[],
	);
};
